export const initialState: MBChatLinkPreviewState = {
  linkPreviewFromUrl: {},
};

export function chatLinkPreviewReducer(
  state: MBChatLinkPreviewState = initialState,
  action: ChatLinkPreviewAction,
): MBChatLinkPreviewState {
  switch (action.type) {
    case 'CHAT:LINK_PREVIEW:UPDATE': {
      const { url, preview } = action.value;
      return {
        ...state,
        linkPreviewFromUrl: {
          ...state.linkPreviewFromUrl,
          [url]: preview,
        },
      };
    }

    default:
      return state;
  }
}
